import React, { useState } from 'react';
import { connectWallet } from '../utils/contractUtils';

function WalletTest() {
  const [account, setAccount] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleConnect = async () => {
    setLoading(true);
    setError('');
    
    try {
      // Use the connectWallet function correctly - extract the address property
      const walletData = await connectWallet();
      setAccount(walletData.address);
      console.log('Connected successfully:', walletData);
    } catch (err) {
      console.error('Connection error:', err);
      setError(err.message || 'Failed to connect');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: '800px', margin: '40px auto', padding: '20px' }}>
      <h1>Wallet Connection Test</h1>
      
      {!account ? (
        <div>
          <p>Please connect your wallet to continue.</p>
          <button 
            onClick={handleConnect}
            disabled={loading}
            style={{
              padding: '10px 20px',
              backgroundColor: loading ? '#cccccc' : '#4CAF50',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: loading ? 'not-allowed' : 'pointer'
            }}
          >
            {loading ? 'Connecting...' : 'Connect Wallet'}
          </button>
        </div>
      ) : (
        <div>
          <p>Connected Account: {account}</p>
          <button 
            onClick={() => setAccount('')}
            style={{
              padding: '10px 20px',
              backgroundColor: '#f44336',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Disconnect
          </button>
        </div>
      )}
      
      {error && (
        <div style={{ 
          color: 'red', 
          backgroundColor: '#ffe6e6',
          padding: '10px',
          borderRadius: '4px',
          marginTop: '20px'
        }}>
          Error: {error}
        </div>
      )}
    </div>
  );
}

export default WalletTest;